import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminDispatchersPage } from '../../../../components/pages/backoffice/platform/platform-admin-jobs-page/platform-admin-dispatchers-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/dispatchers/')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminDispatchersPage />
    </PermissionChecker>
  ),
})
